import React from "react";
import Layout from "../../layout/adminExt/Layout";
import Settings from "./Settings";

export default function Index() {
  return (
    <Layout>
      <Settings />
    </Layout>
  );
}
